exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-pagination {\n  margin-top: 20px;\n  text-align: right;\n}\n.partner-manage-page .cell-content {\n  color: #008080;\n  cursor: pointer;\n  text-decoration: underline;\n  display: inline-block;\n  padding: 6px 10px;\n  line-height: 1.3em;\n}\n", ""]);

// exports
